import { eq } from "fp-ts";
import { constFalse } from "fp-ts/function";
import * as t from "io-ts";
import { apiCall } from "../../APICall";

const NeosStatus = t.type({
  ok: t.boolean,
});

export const getNeosStatus = apiCall({
  path: ["packages", "loans", "neos", "status"],
  inputEq: eq.fromEquals(constFalse),
  inputCodec: t.void,
  outputCodec: NeosStatus,
});

const NeosFlag = t.type({
  flag: t.boolean,
  popUp: t.boolean,
});

export const getNeosFlag = apiCall({
  path: ["packages", "loans", "neos", "flag"],
  inputEq: eq.fromEquals(constFalse),
  inputCodec: t.void,
  outputCodec: NeosFlag,
});

export const getGdprRequired = apiCall({
  path: ["packages", "loans", "neos", "gdprRequired"],
  inputEq: eq.fromEquals(constFalse),
  inputCodec: t.void,
  outputCodec: t.boolean,
});

export const saveGdprConsent = apiCall({
  path: ["packages", "loans", "neos", "saveGdprConsent"],
  inputEq: eq.fromEquals(constFalse),
  inputCodec: t.void,
  outputCodec: t.union([t.void, t.null, t.undefined]),
});

const NeosLink = t.type({
  link: t.string,
});
export const getLink = apiCall({
  path: ["packages", "loans", "neos", "getLink"],
  inputEq: eq.fromEquals(constFalse),
  inputCodec: t.void,
  outputCodec: NeosLink,
});

const NeosShareLinkRequest = t.type({
  channel: t.string,
});

const NeosShareLinkResponse = t.type({
  remainingAttempts: t.number,
});
export const shareLink = apiCall({
  path: ["packages", "loans", "neos", "shareLink"],
  inputEq: eq.fromEquals(constFalse),
  inputCodec: NeosShareLinkRequest,
  outputCodec: NeosShareLinkResponse,
});

const NeosVerificationResult = t.type({
  verificationResult: t.union([
    t.undefined,
    t.null,
    t.literal("fail"),
    t.literal("ok"),
  ]),
});
export const getNeosVerificationResult = apiCall({
  path: ["packages", "loans", "neos", "getVerificationResult"],
  inputEq: eq.fromEquals(constFalse),
  inputCodec: t.void,
  outputCodec: NeosVerificationResult,
});
